const AGREEMENT_KEY = "personal_data_agreed_at"
const REVISION_KEY = "personal_data_agreed_revision"
const AGREEMENT_TTL_MS = 365 * 24 * 60 * 60 * 1000

export type PersonalDataConsentPayload = {
  documentSlug: "privacy"
  documentRevision: number
  source: "gDaksbyWeb"
}

export function loadPersonalDataConsent(
  currentRevision?: number | null
): boolean {
  try {
    const savedAt = localStorage.getItem(AGREEMENT_KEY)
    if (!savedAt) return false
    const elapsed = Date.now() - Number(savedAt)
    if (!Number.isFinite(elapsed) || elapsed >= AGREEMENT_TTL_MS) {
      localStorage.removeItem(AGREEMENT_KEY)
      localStorage.removeItem(REVISION_KEY)
      return false
    }
    if (currentRevision != null && Number.isFinite(currentRevision)) {
      const savedRevision = Number(localStorage.getItem(REVISION_KEY))
      if (
        !Number.isFinite(savedRevision) ||
        savedRevision < currentRevision
      ) {
        return false
      }
    }
    return true
  } catch {
    return false
  }
}

export function savePersonalDataConsent(revision: number): void {
  try {
    localStorage.setItem(AGREEMENT_KEY, String(Date.now()))
    localStorage.setItem(REVISION_KEY, String(revision))
  } catch {
    // ignore
  }
}

export function clearPersonalDataConsent(): void {
  try {
    localStorage.removeItem(AGREEMENT_KEY)
    localStorage.removeItem(REVISION_KEY)
  } catch {
    // ignore
  }
}

export function getSavedPersonalDataConsentPayload(): PersonalDataConsentPayload | null {
  try {
    const savedAt = localStorage.getItem(AGREEMENT_KEY)
    if (!savedAt) return null
    const revision = Number(localStorage.getItem(REVISION_KEY))
    if (!Number.isFinite(revision) || revision < 1) return null
    return {
      documentSlug: "privacy",
      documentRevision: revision,
      source: "gDaksbyWeb",
    }
  } catch {
    return null
  }
}
